import { useNotificationsControllerGetSubscriptionInfo } from "@semo/api-contracts";

/**
 * 로그인한 사람의 «내 알림·채팅 목록» 실시간 채널 이름 — 서버가 정해 API 로 준다(X-01).
 *
 * 예전에는 화면이 `buyer_<회원 번호>_notifications` 를 스스로 만들어 구독했다. 그 이름은 번호만
 * 알면 누구나 만들 수 있어, 서버가 이름에 비밀 조각을 붙이면(REALTIME_CHANNEL_SECRET) 화면은
 * 더 이상 이름을 만들 수 없다. 그래서 알림 구독 정보(GET /notifications/subscription-info —
 * 본인 채널만 준다)에서 받은 이름을 그대로 쓴다.
 *
 * 같은 질의 키를 useNotificationsRealtime 과 나눠 쓰므로 요청은 한 번만 나간다.
 * 이름을 받기 전에는 `undefined` — 호출부는 그때 구독하지 않는다.
 */
export function useUserRealtimeChannelName(
  enabled = true,
): string | undefined {
  const { data } = useNotificationsControllerGetSubscriptionInfo({
    query: {
      enabled,
      staleTime: 5 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  });
  const channelName = data?.data?.channels[0]?.channelName;
  return channelName === undefined || channelName === ""
    ? undefined
    : channelName;
}
